import _ from 'lodash'
import { useEffect, useState } from 'react'
import TagManager from 'react-gtm-module'
import { ICourse } from 'stores/courses'
import { convertToEcommerceItem } from '@/shared/utils/convertFormatForGTM'

// GA 향상된 전자상거래 - enhanced ecommerce
// GA4 전자상거래 - ecommerce
export const useViewItem = (course: ICourse, courseId: string) => {
  const [isPushed, setIsPushed] = useState(false)

  useEffect(() => {
    if (_.isEmpty(course) || course.id !== courseId || isPushed) return
    TagManager.dataLayer({
      dataLayer: {
        ecommerce: null,
      },
    })
    // GA4
    TagManager.dataLayer({
      dataLayer: {
        event: 'view_item',
        ecommerce: {
          items: [convertToEcommerceItem(course)],
        },
        ...(sessionStorage.getItem('utmAndGclid') &&
          JSON.parse(sessionStorage.getItem('utmAndGclid') as string)),
      },
    })
    setIsPushed(true)
  }, [course, courseId, isPushed])
}
